import { useCallback, useMemo } from 'react';

import useAppSelector from '~hooks/useAppSelector';
import { selectUserState } from '~store/selectors';

export type REPLACEMENT_MAP = Map<string, string | number>;

export default function useDynamicTextReplacement() {
  const userState = useAppSelector(selectUserState);

  const replace = useCallback((map: REPLACEMENT_MAP, value: string) => {
    try {
      const regReplace = new RegExp(Array.from(map.keys()).join('|'), 'gi');
      return value.replace(regReplace, matched => `${map.get(matched) || matched}`);
    } catch (_) {
      // Silently return the unchanged text
      return value;
    }
  }, []);

  return useMemo(() => {
    const replacementMap: REPLACEMENT_MAP = new Map();
    replacementMap.set('{{user.firstName}}', userState.firstName);
    replacementMap.set('{{user.lastName}}', userState.lastName);
    replacementMap.set('{{user.email}}', userState.email);
    replacementMap.set('{{user.id}}', userState.id);
    replacementMap.set('{{user.country}}', userState.country);
    replacementMap.set('{{user.currentLanguage}}', userState.currentLanguage);
    replacementMap.set('{{user.uuid}}', userState.uuid);

    const replaceFn = (value: string) => replace(replacementMap, value);

    return { replacementMap, replace: replaceFn };
  }, [
    userState.country,
    userState.currentLanguage,
    userState.email,
    userState.firstName,
    userState.id,
    userState.lastName,
    userState.uuid,
    replace,
  ]);
}
